import { BuildingsIcon } from '@phosphor-icons/react';
import { cn } from '@skupreme/shared/ui';

/** An account's workspace icon: its logo when it has one (the switcher
    answers `logoUrl`), else the building. Sized for the plate `OrgMark`
    draws: `sm` for a list row, `md` for the switcher's button. */
export function AccountMark({
  logoUrl,
  size = 'sm',
}: {
  logoUrl?: string | null;
  size?: 'sm' | 'md';
}) {
  const small = size === 'sm';
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt=""
        className={cn('sk:object-contain', small ? 'sk:size-3.5' : 'sk:size-6')}
      />
    );
  }
  return <BuildingsIcon size={small ? 12 : 18} />;
}

/** The switcher's closed label: the place the portal shows, and only that.
    At the account level that is the account; else the division. */
export function switcherLabel({
  atAccount,
  accountName,
  divisionName,
  accountLevelLabel,
}: {
  atAccount: boolean;
  accountName?: string;
  divisionName: string;
  /** Said at the account level when the account's name is not known. */
  accountLevelLabel: string;
}): string {
  if (atAccount) return accountName || accountLevelLabel;
  return divisionName;
}
